export const ORDER_SUMMARY = {
  ID: 'orderSummary',
  TITLE: 'Resumen del pedido',
  BUTTON_CUSTOM_ERROR: {
    MI_MOVISTAR:
      'Pulsa "siguiente paso" para completar el resto de campos obligatorios del formulario',
  },
  TERMS_AND_CONDITIONS_CHECK: {
    NAME: 'termsAndConditionsCheck',
    ID: 'terms-and-conditions-Check',
    LABEL: 'He leído y',
    BUTTON_TEXT:
      'acepto las condiciones generales, particulares y de desistimiento',
    RULES: {
      REQUIRED: 'Debes aceptar las condiciones',
    },
  },
  AFR_UPDATE_NOTE: 'La instalación será sobre radio con velocidad hasta 1 Gb',
};
